export default {
  hero: {
    title: "Who am I?",
    greeting:
      "Hi, I'm Javad — Technical and Team Lead, driving full-cycle product engineering from hardware to software.",
    intro:
      "I've designed and built hardware, and extended that into leading full-cycle software delivery from architecture to deployment. As a Technical and Team Lead, I guide products end-to-end — from early hardware concepts through shipped web, mobile and desktop software — bringing DevOps discipline and hands-on project management to every release.",
  },
  connect: {
    title: "Connect With Me",
    subtitle:
      "Let's build something amazing together! Reach out through any of these platforms.",
  },
  socialAriaLabel: "Javad's {{label}}",
  socialLabels: {
    email: "Email",
    website: "Website",
    linkedin: "LinkedIn",
    github: "GitHub",
    telegram: "Telegram",
    instagram: "Instagram",
    youtube: "YouTube",
    twitter: "Twitter",
    facebook: "Facebook",
  },
};
